import React, { useEffect } from 'react';
import { ErrorState } from '../../../components/states';
// import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';
import UserInstitutionForm from '../../../components/forms/UserInstitutionForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function UserInstitutionPage() {
  // const { t } = useTranslation();
  // const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/users/institutions`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <UserInstitutionForm defaultValues={data?.data} /> : <Loader />;
}
